import UAParser from 'ua-parser-js'

export const browserParser = new UAParser()

const getMobileDetect = (deviceType?: string) => {
  const isMobile = () => Boolean(deviceType?.match(/mobile/i))
  const isTablet = () => Boolean(deviceType?.match(/tablet/i))

  return {
    isMobile,
    isTablet,
  }
}

const useMobileDetect = () => {
  const deviceType = browserParser.getDevice().type
  return getMobileDetect(deviceType)
}

export default useMobileDetect
